import { GenericComponentFactory } from 'base/components/GenericComponent';
import { useClassName } from '@/styles/CheckoutBody';

const GenericComponent = GenericComponentFactory({ useClassName });
const Body = GenericComponent({ as: 'div', styles: { key: '' } });

export const CheckoutBody = Body;
